import React from 'react'
import { IGatsbyImageData, GatsbyImage } from 'gatsby-plugin-image'
import { BaseHtmlRendering } from '../../base/BaseHtmlRendering'

export const LandingPageDescription = ({
  description,
  mainMedia,
  title,
}: {
  description: Queries.AllPagesQuery['allStrapiLandingPage']['nodes'][0]['landingPageDynamicZone'][0]['description']
  mainMedia: Queries.AllPagesQuery['allStrapiLandingPage']['nodes'][0]['landingPageDynamicZone'][0]['mainMedia']
  title: string
}) => {
  if (!description?.data?.description || !mainMedia?.localFile?.childImageSharp?.gatsbyImageData) {
    return null
  }

  return (
    <section className="grid grid-cols-1 gap-10 p-6 md:grid-cols-2 rounded-xl bg-lamacompta-blue">
      <div>
        <GatsbyImage
          image={mainMedia?.localFile?.childImageSharp?.gatsbyImageData as IGatsbyImageData}
          alt="header"
          className="object-cover w-full h-full rounded-xl"
        />
      </div>
      <div className='space-y-4'>
        {title && <h2 className="text-2xl font-bold text-night">{title}</h2>}
        <BaseHtmlRendering
          html={description?.data?.description}
          className="text-xs md:text-base text-night"
        />
      </div>
    </section>
  )
}
